<section class="full-width full-height">
  <mat-card class="flex-column full-width full-height">
    <mat-card-content class="flex full-height full-width">
      <article class="full-height flex-row">
        <ng-container *ngIf="isViewModeDesignsList()">
          <app-drawing-library-listview
            class="full-height full-width"
            [isProductionSchedule]="true"
            [showSelectedItems]="showSelectedItems"
            [canSelectDrawings]="canSelectDrawings()"
            [productionScheduleItemMultiplier]="productionSchedule.getProductionScheduleItemMultiplier()"
            [hideMissingDesigns]="true"
            [showConfigurations]="true"
            [isPreSelection]="isPreSelection"
            [filterOnDrawingType]="filterOnBMPDrawingType"
            [selectedPath]="selectedPath"
            [pathWidths]="pathWidths"
            [selectedRestPathColoredYarnSet]="selectedRestPathColoredYarnSet"
            [productionSchedulePathsOfColoredYarnSet]="productionSchedulePathsOfColoredYarnSet"
            [availableSpaceInBuggyInPicks]="availableSpaceInBuggyInPicks"
            [buggyLengthMaxInPicks]="buggyLengthMaxInPicks"
            [productionSchedule]="productionSchedule"
            [preselectedDesignIds]="preselectedDesignIds"
            [preselectedConfigurationIds]="preselectedConfigurationIds"
            [selectedPathContentRowData]="selectedPathContentRowData"
            (drawingIdSelected)="onDrawingIdsSelected($event)"
            (configurationIdSelected)="onConfigurationIdsSelected($event)"
            (drawingSelected)="onDrawingSelected($event)"
            (selectedViewModeChanged)="onSelectedViewModeChange($event)"
            (navigateBackOutput)="navigateBackOutput.emit()"
            (selectedPathOutput)="selectedPathOutput.emit($event)"
            (selectedRestPathColoredYarnSetOutput)="selectedRestPathColoredYarnSetOutput.emit($event)"
          ></app-drawing-library-listview>
        </ng-container>

        <ng-container *ngIf="isViewModeGroupedDrawings()">
          <app-drawings-grouped-view
            class="full-height full-width"
            [productionSchedule]="productionSchedule"
            [isPreSelection]="isPreSelection"
            [selectedPath]="selectedPath"
            [selectedRestPathColoredYarnSet]="selectedRestPathColoredYarnSet"
            [productionSchedulePathsOfColoredYarnSet]="productionSchedulePathsOfColoredYarnSet"
            [productionScheduleItemMultiplier]="productionSchedule.getProductionScheduleItemMultiplier()"
            [availableSpaceInBuggyInPicks]="availableSpaceInBuggyInPicks"
            [buggyLengthMaxInPicks]="buggyLengthMaxInPicks"
            [preselectedDesignIds]="preselectedDesignIds"
            [preselectedConfigurationIds]="preselectedConfigurationIds"
            [preselectedDrawings]="preselectedDrawings"
            [selectedPathContentRowData]="selectedPathContentRowData"
            (drawingIdSelected)="onDrawingIdsSelected($event)"
            (configurationIdSelected)="onConfigurationIdsSelected($event)"
            (selectedViewModeChanged)="onSelectedViewModeChange($event)"
            (selectedPathOutput)="selectedPathOutput.emit($event)"
            (selectedRestPathColoredYarnSetOutput)="selectedRestPathColoredYarnSetOutput.emit($event)"
          ></app-drawings-grouped-view>
        </ng-container>

        <ng-container *ngIf="isViewModeNewOrderLines()">
          <app-drawing-library-order-lines-view
            class="full-height full-width"
            [productionOrderCustomSettings]="productionOrderCustomSettings"
            [commercialUnit]="commercialUnit"
            [productionSchedule]="productionSchedule"
            [isPreSelection]="isPreSelection"
            [preselectedOrderlineIds]="preselectedOrderlineIds"
            (orderlineSelected)="onOrderlinesSelected($event)"
            (selectedViewModeChanged)="onSelectedViewModeChange($event)"
            [selectedPath]="selectedPath"
            [pathWidths]="pathWidths"
            [selectedRestPathColoredYarnSet]="selectedRestPathColoredYarnSet"
            [productionSchedulePathsOfColoredYarnSet]="productionSchedulePathsOfColoredYarnSet"
            [productionScheduleItemMultiplier]="productionSchedule.getProductionScheduleItemMultiplier()"
            [availableSpaceInBuggyInPicks]="availableSpaceInBuggyInPicks"
            [buggyLengthMaxInPicks]="buggyLengthMaxInPicks"
            [marginInDentsOfMissingDesigns]="marginInDentsOfMissingDesigns"
            [addProductionScheduleNavigationState]="addProductionScheduleNavigationState"
            [selectedPathContentRowData]="selectedPathContentRowData"
            (navigateBackOutput)="navigateBackOutput.emit()"
            (selectedPathOutput)="selectedPathOutput.emit($event)"
            (selectedRestPathColoredYarnSetOutput)="selectedRestPathColoredYarnSetOutput.emit($event)"
          ></app-drawing-library-order-lines-view>
        </ng-container>

        <ng-container *ngIf="isViewModeNewGroupedOrderLines()">
          <app-drawing-library-order-lines-grouped-view
            class="full-height full-width"
            [productionOrderCustomSettings]="productionOrderCustomSettings"
            [commercialUnit]="commercialUnit"
            [displayTechnicalUnit]="displayTechnicalUnit"
            [productionSchedule]="productionSchedule"
            [isPreSelection]="isPreSelection"
            [selectedPath]="selectedPath"
            [pathWidths]="pathWidths"
            [availableSpaceInBuggyInPicks]="availableSpaceInBuggyInPicks"
            [buggyLengthMaxInPicks]="buggyLengthMaxInPicks"
            [preselectedOrderlineIds]="preselectedOrderlineIds"
            [selectedRestPathColoredYarnSet]="selectedRestPathColoredYarnSet"
            [productionSchedulePathsOfColoredYarnSet]="productionSchedulePathsOfColoredYarnSet"
            [marginInDentsOfMissingDesigns]="marginInDentsOfMissingDesigns"
            [addProductionScheduleNavigationState]="addProductionScheduleNavigationState"
            [productionScheduleItemMultiplier]="productionSchedule.getProductionScheduleItemMultiplier()"
            [selectedPathContentRowData]="selectedPathContentRowData"
            (selectedOrderlineIdsChanged)="onOrderlinesSelected($event)"
            (selectedViewModeChanged)="onSelectedViewModeChange($event)"
            (selectedPathOutput)="selectedPathOutput.emit($event)"
            (selectedRestPathColoredYarnSetOutput)="selectedRestPathColoredYarnSetOutput.emit($event)"
          ></app-drawing-library-order-lines-grouped-view>
        </ng-container>

        <ng-container *ngIf="isViewModeNewGroupedDesignThumbnails()">
          <app-drawing-library-grouped-design-thumbnails-view
            class="full-height full-width"
            [productionSchedule]="productionSchedule"
            [isPreSelection]="isPreSelection"
            [selectedPath]="selectedPath"
            [selectedRestPathColoredYarnSet]="selectedRestPathColoredYarnSet"
            [productionSchedulePathsOfColoredYarnSet]="productionSchedulePathsOfColoredYarnSet"
            [productionScheduleItemMultiplier]="productionSchedule.getProductionScheduleItemMultiplier()"
            [availableSpaceInBuggyInPicks]="availableSpaceInBuggyInPicks"
            [buggyLengthMaxInPicks]="buggyLengthMaxInPicks"
            [preselectedDrawings]="preselectedDrawings"
            [preselectedDesignIds]="preselectedDesignIds"
            [preselectedConfigurationIds]="preselectedConfigurationIds"
            [selectedPathContentRowData]="selectedPathContentRowData"
            (drawingIdSelected)="onDrawingIdsSelected($event)"
            (configurationIdSelected)="onConfigurationIdsSelected($event)"
            (selectedViewModeChanged)="onSelectedViewModeChange($event)"
            (selectedPathOutput)="selectedPathOutput.emit($event)"
            (selectedRestPathColoredYarnSetOutput)="selectedRestPathColoredYarnSetOutput.emit($event)"
          ></app-drawing-library-grouped-design-thumbnails-view>
        </ng-container>
      </article>
    </mat-card-content>
  </mat-card>
</section>
